import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyPortal from '@hooks/useAgencyPortal'
import useAgencyPortals from '@hooks/useAgencyPortals'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import PortalAgencyListItem from './PortalAgencyListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'agency_title',
      label: 'Filter by Title or ID',
    },
  ]
}

interface PortalAgenciesProps {
  portalId: number,
}

const PortalAgencies = (props: PortalAgenciesProps) => {
  const { portalId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const agencyPortalsPayload = useAgencyPortals({
    filters: {
      portal_id: portalId,
      ...pageFilters,
    },
    performHttpRequests: !!portalId,
    requestOptions: {
      include_agency_portal_agency: true,
      include_agency_portal_auth_token: true,
    },
    sortKey: 'agencyTitle',
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyPortals,
    filteredAgencyPortalsCount,
    hasFilteredAgencyPortals,
    loading,
  } = agencyPortalsPayload

  const {
    callbacks: { createOrEditAgencyPortal },
  } = useAgencyPortal({ portal_id: portalId })

  return (
    <DashboardModule
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Agencies"
    >
      <Box flexDirection="column">
        <DashboardModuleFilters
          filterFields={buildPageFilterFields()}
          {...filterPayload}
        />

        {!loading && !hasFilteredAgencyPortals && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Agencies present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please adjust your filters or create one below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAgencyPortals && (
          <DashboardModule.ScrollableSection>
            {filteredAgencyPortals.map(agencyPortal => (
              <PortalAgencyListItem
                agencyPortal={agencyPortal}
                key={agencyPortal.id}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyPortalsCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            // @ts-expect-error TS2554
            onClick={() => createOrEditAgencyPortal()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Agency
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default PortalAgencies
